// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__aAt3T","image":"Header_image__2OIg6","name":"Header_name__3aZ8D","info":"Header_info___k9is","infoRow":"Header_infoRow__19EPF"};